<template>
  <div class="tooltip">
    <div class="tooltip-body">
      {{ tooltipText }}
    </div>
    <div class="tooltip-footer">
      <div class="footer-button">
        <router-link v-show="prevStep" :to="{ path: prevStep }" class="footer-button-text">‹ Back</router-link>
      </div>
      <div class="footer-button">
        <router-link v-show="nextStep" :to="{ path: nextStep }" class="footer-button-text">Next Step ›</router-link>
      </div>
    </div>
    <div class="arrow"></div>
  </div>
</template>

<script>
import steps from '../utils/browserHistory.js';

export default {
  name: 'Tooltip',
  props: {
    currentStep: {
      type: String,
      required: true
    }
  },
  computed: {
    nextStep: function() {
      return steps.nextStep(this.currentStep)
    },
    prevStep: function() {
      return steps.prevStep(this.currentStep)
    },
    tooltipText: function() {
      return steps.tooltipText(this.currentStep)
    },
  }
}
</script>

<style scoped>
@import "../styles/colors.css";
@import "../styles/consts.css";

.tooltip {
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  padding: 0;
  width: 252px;
  min-height: 182px;
  height: auto;
  border-radius: 2px;
  box-shadow: $tooltip-box-shadow;
  background-color: $white;
  border: solid 1px $white-smoke;
  outline: none;
  z-index: 100;
}

.arrow {
  border: $white;
  box-shadow: $tooltip-box-shadow;

  &:after, &:before {
    right: 100%;
    top: 42px;
    border: solid transparent;
    content: " ";
    height: 0;
    width: 0;
    position: absolute;
    pointer-events: none;
  }

  &:after {
    border-right-color: $white;
    border-width: 12px;
    margin-top: -12px;
  }
  &:before {
    border-right-color: $white-smoke;;
    border-width: 13px;
    margin-top: -13px;
  }
}

.tooltip-body {
  flex-grow: 1;
  padding: 20px 30px;
  @include proxima_light;
  font-size: 18px;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.78;
  letter-spacing: normal;
  text-align: left;
  color: $spanish-gray;
}

.tooltip-footer {
  height: 45px;
  display: flex;
  border-top: 1px solid $isabelline;
}

.footer-button {
  width: 50%;

  &:first-child {
    border-right: 1px solid $isabelline;
  }

  &-text {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    color: $nickel;

    &:hover {
      background-color: $ghost-white;
      color: $dark-blue;
      cursor: pointer;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Tooltip.vue